<template>
  <div class="d-inline-flex align-items-center gap-2">
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      :aria-label="$t('forwards.mandates.year_previous')"
      :disabled="model <= TIMELINE_YEAR_MIN"
      @click="step(-1)"
    >
      <FontAwesomeIcon icon="fa-solid fa-chevron-left" />
    </button>
    <span class="forwards-year-label fw-semibold">{{ model }}</span>
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      :aria-label="$t('forwards.mandates.year_next')"
      :disabled="model >= TIMELINE_YEAR_MAX"
      @click="step(1)"
    >
      <FontAwesomeIcon icon="fa-solid fa-chevron-right" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { TIMELINE_YEAR_MAX, TIMELINE_YEAR_MIN } from "@/forwards2/periodUtils";

/**
 * The mandates timeline's only date control: the calendar year on screen, stepped one year at a time.
 * The model is what the timeline endpoint takes as `year`.
 */
const model = defineModel<number>({ required: true });

const step = (delta: number) => {
  model.value += delta;
};
</script>

<style scoped lang="scss">
.forwards-year-label {
  font-size: 0.8125rem;
  white-space: nowrap;
}
</style>
